import React from 'react';
import { Box, Flex } from 'native-base';
import { Text } from '../../atoms';
import { variantStyles } from './tagVariantStyle';
export function DefaultTag({ variant = 'primary', tagText = 'Generic Tag', customVariantStyle, testID, }) {
    const styleData = customVariantStyle ?? variantStyles[variant] ?? variantStyles.primary;
    return (React.createElement(Flex, { display: "inline-flex", alignItems: "start", justifyContent: "start", nativeID: testID },
        React.createElement(Box, { px: "2", py: "3px", borderStyle: "solid", borderWidth: "1", borderRadius: "5", bg: styleData.bgColor, borderColor: styleData.borderColor },
            React.createElement(Text, { color: styleData.textColor, fontToken: styleData.fontToken }, tagText))));
}
